const translations = {
    en: {
        soon: "Soon",
        hometitle: "Home",
        jobtitle:"My works",
        clientstitle:"Clients",
        contacttitle:"Contact me",
        gamestitle:"My games",
        blackjacktitle:"BlackJack Simulator",
        knowme:"Know me",
        quote:"Programmer specialized in web page development",
        errorback:"Back to home",
        startto:"Start designing",
        future: "your future",
        altenglishflag : "English flag",
        altspainflag: "Spain flag",
        altcatalanflag: "Catalan flag",
        menualt: "Light bulb. Drop-down menu button",
        altitoldyoulogo:"Logo of I Told You",
        altsuntakalogo:  "Logo of Sun Taka",
        altdramalogo: "Logo of Drama",
        altlxrylogo: "Logo of LxryFootball",
        altfarologo: "Logo of Faro Castelldefels",
        altfirmapere: "Pere Martínez Ibar signature",
        altdolfinpreview:"Preview of Dolfin's website",
        altsuntakapreview:"Preview of Sun Taka's website",
        altitoldyoupreview:"Preview of I Told You's website",
        altdramapreview:"Preview of Drama's website",
        altlxrypreview:"Preview of LxryFootball's website",
        altfaropreview:"Preview of Faro Castelldefels's website",
        altblackjack:"Preview of BlackJack game",
        altchess:"Preview of Chess game",
        altsoberblood:"Preview of SoberBlood app",
        about:"Programming has allowed me to develop an organized and methodical approach to problem solving. I enjoy the continuous learning process and the satisfaction of seeing how my constant efforts translate into efficient solutions. My passion for programming is based on discipline and persistence, always looking to improve and optimize each project.",
        jobtooltip: "Website image",
        apptooltip: "App image",
        androidOnly: "Only available on Android mobile"
      },
      es: {
        soon: "Próximamente",
        hometitle: "Inicio",
        jobtitle:"Mis trabajos",
        clientstitle:"Clientes",
        contacttitle:"Contáctame",
        gamestitle:"Mis juegos",
        blackjacktitle:"Simulador de BlackJack",
        knowme:"Conóceme",
        quote:"Programador especializado en el desarrollo de páginas web",
        errorback:"Volver al inicio",
        startto:"Empieza a",
        future: "diseñar tu futuro",
        altenglishflag : "Bandera inglesa",
        altspainflag: "Bandera española",
        altcatalanflag: "Bandera catalana",
        menualt: "Bombilla. Botón de menú desplegable",
        altitoldyoulogo:"Logotipo de I Told You",
        altsuntakalogo:  "Logotipo de Sun Taka",
        altdramalogo: "Logotipo de Drama",
        altlxrylogo: "Logotipo de LxryFootball",
        altfarologo: "Logotipo de Faro Castelldefels",
        altfirmapere: "Firma de Pere Martínez Ibar",
        altdolfinpreview:"Vista previa de la web de Dolfin",
        altsuntakapreview:"Vista previa de la web de Sun Taka",
        altitoldyoupreview:"Vista previa de la web de I Told You",
        altdramapreview:"Vista previa de la web de Drama",
        altlxrypreview:"Vista previa de la web de LxryFootball",
        altfaropreview:"Vista previa de la web de Faro Castelldefels",
        altblackjack:"Vista previa del juego de BlackJack",
        altchess:"Vista previa del juego de ajedrez",
        altsoberblood:"Vista previa de la app de SoberBlood",
        about:"La programación me ha permitido desarrollar un enfoque organizado y metódico para resolver problemas. Disfruto del proceso de aprendizaje continuo y la satisfacción de ver cómo mis esfuerzos constantes se traducen en soluciones eficientes. Mi pasión por la programación se basa en la disciplina y la persistencia, siempre buscando mejorar y optimizar cada proyecto.",
        jobtooltip: "Imagen del sitio web",
        apptooltip: "Imagen de la app",
        androidOnly: "Solo disponible para móviles Android"
      },
      ca: {
        soon: "Properament",
        hometitle: "Inici",
        jobtitle:"La meva feina",
        clientstitle:"Clients",
        contacttitle:"Contacta'm",
        gamestitle:"Els meus jocs",
        blackjacktitle:"Simulador de BlackJack",
        knowme:"Coneix-me",
        quote:"Programador especialitzat en el desenvolupament de pàgines web",
        errorback:"Tornar al inici",
        startto:"Comença a",
        future: "dissenyar el teu futur",
        altenglishflag : "Bandera anglesa",
        altspainflag: "Bandera espanyola",
        altcatalanflag: "Bandera catalana",
        menualt: "Bombeta. Botó de menú desplegable",
        altitoldyoulogo:"Logotip de I Told You",
        altsuntakalogo:  "Logotip de Sun Taka",
        altdramalogo: "Logotip de Drama",
        altlxrylogo: "Logotip de LxryFootball",
        altfarologo: "Logotip de Faro Castelldefels",
        altfirmapere: "Firma de Pere Martínez Ibar",
        altdolfinpreview:"Vista prèvia de la web de Dolfin",
        altsuntakapreview:"Vista prèvia de la web de Sun Taka",
        altitoldyoupreview:"Vista prèvia de la web de I Told You",
        altdramapreview:"Vista prèvia de la web de Drama",
        altlxrypreview:"Vista prèvia de la web de LxryFootball",
        altfaropreview:"Vista prèvia de la web de Faro Castelldefels",
        altblackjack:"Vista prèvia del joc de BlackJack",
        altchess:"Vista prèvia del joc d'escacs",
        altsoberblood:"Vista prèvia de la app de SoberBlood",
        about:"La programació m'ha permès desenvolupar un enfocament organitzat i metòdic per a resoldre problemes. Gaudeixo del procés d'aprenentatge continu i la satisfacció de veure com els meus esforços constants es tradueixen en solucions eficients. La meva passió per la programació es basa en la disciplina i la persistència, sempre buscant millorar i optimitzar cada projecte.",
        jobtooltip: "Imatge del lloc web",
        apptooltip: "Imatge de l'app",
        androidOnly: "Només disponible per a mòbils Android"
      }
};

export default translations;